
import * as React from "react";
import { Api } from "../../../lib/Api";
import { Lng } from "../../../../languages/Languages";


interface IResetPasswordProps {

}

interface IResetPasswordState {
    success : string
    error   : string
    form    : IForm
    loading : boolean
}

interface IForm{
    email   : string
}

export interface IResponse{
    success : string
    error   : string
}

export default class ResetPassword extends React.Component<IResetPasswordProps, IResetPasswordState>{

    constructor(props:IResetPasswordProps){
        super(props);
        this.state = {
            success                 : null,
            error                   : null,
            form                    : {
                email           : ''
            },
            loading                 : false
        };
    }

    private submitHandler(evt): void {
        let saveData        = this.state.form;
        if ( evt !== null ) {
            evt.preventDefault();
        }
        this.setState({
            loading: true
        }, () =>{
            Api.call('/resetPassword', saveData, (result:IResponse)=>{
                this.setState({
                    success:    result.success,
                    error:      result.error,
                    loading:    false
                });
            });
        });
    }

    private changeInputHandler(evt, type:string): void {
        evt.preventDefault();
        var form = this.state.form;
        form[type] = evt.target.value;
        this.setState({
            form: form
        });
    }

    render() {
        return (
            <>
                <form method="post" onSubmit={e => this.submitHandler(e)}>
                    <div className="text-center">
                        <div className="circle">
                            <img src="img/login/user_icon.svg" width={35} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p className = "description">{Lng.get('resetpw_enteremail')}</p>
                            <div className="form-row">
                                <div className="col">
                                    <input className="s-form-control" type="email" required={true} placeholder={Lng.get('resetpw_enteremailinput')} name="email" value={this.state.form.email} onChange={ e => this.changeInputHandler(e,'email') } />
                                </div>
                            </div>
                        </div>
                    </div>
                    { this.state.error !== null || this.state.success !== null?<>
                        <div className="form-row" style={{
                            marginTop: '15px'
                        }}>
                            <div className="col-sm-12">
                                { this.state.error !== null?<div className="alert alert-danger">
                                    { this.state.error }
                                </div>:''}
                                { this.state.success !== null?<div className="alert alert-success">
                                    { this.state.success }
                                </div>:''
                                }
                            </div>
                        </div>
                    </>:'' }

                    { this.state.success === null?<div className="row">
                        <div className="col-12">
                            <button className="green_btn btn-block" id="send_password_reset_email_btn" type="submit" disabled={this.state.loading}>{this.state.loading?Lng.get('resetpw_sending'):Lng.get('resetpw_sendbtn')}</button>
                        </div>
                    </div>:'' }
                </form>
			</>
        );
    }
}
